const Icon = () => {
  return (
    <svg width='24' height='24' viewBox='0 0 24 24' fill='none' xmlns='http://www.w3.org/2000/svg'>
      <path
        d='M11.9688 0.00214432C11.9688 0.00214432 19.0439 -0.315123 22.7937 6.76868H11.3671C11.3671 6.76868 9.2091 6.69796 7.36952 9.30633C6.83899 10.399 6.2731 11.5268 6.90975 13.7467C5.99004 12.1964 2.02783 5.32383 2.02783 5.32383C2.02783 5.32383 4.82286 0.283971 11.9688 0.00214432Z'
        fill='#C6352E'
      />
      <path
        d='M22.4254 17.9878C22.4254 17.9878 19.1627 24.2499 11.1298 23.9421C12.1207 22.2333 16.8444 14.0844 16.8444 14.0844C16.8444 14.0844 17.9848 12.2581 16.6382 9.36675C15.9536 8.3625 15.2565 7.31019 13.0081 6.74912C14.8164 6.73123 22.771 6.75027 22.771 6.75027C22.771 6.75027 25.754 11.6819 22.4254 17.9878Z'
        fill='#F4D911'
      />
      <path
        d='M1.56249 18.0352C1.56249 18.0352 -2.24961 12.0884 2.03498 5.31226C3.02506 7.02176 7.74618 15.1721 7.74618 15.1721C7.74618 15.1721 8.76325 17.0691 11.9502 17.3532C13.1651 17.2649 14.4287 17.1896 16.0407 15.5305C15.1519 17.0992 11.1575 23.953 11.1575 23.953C11.1575 23.953 5.37921 24.0603 1.56249 18.0352Z'
        fill='#81B354'
      />
      <path
        d='M11.1298 23.9999L12.7371 17.318C12.7371 17.318 14.5043 17.1807 15.9851 15.5615C15.0659 17.1726 11.1298 23.9999 11.1298 23.9999Z'
        fill='#7BAA50'
      />
      <path
        d='M6.58582 12.0749C6.58582 9.12933 8.98242 6.74146 11.9393 6.74146C14.896 6.74146 17.2928 9.12928 17.2928 12.0749C17.2928 15.0206 14.8961 17.4085 11.9393 17.4085C8.98242 17.4085 6.58582 15.0206 6.58582 12.0749Z'
        fill='white'
      />
      <path
        d='M7.48169 12.0749C7.48169 9.62243 9.47728 7.63428 11.9392 7.63428C14.4007 7.63428 16.3965 9.62243 16.3965 12.0749C16.3965 14.5274 14.4007 16.5157 11.9392 16.5157C9.47728 16.5157 7.48169 14.5273 7.48169 12.0749Z'
        fill='url(#paint0_linear_250_519)'
      />
      <path
        d='M22.7711 6.75027L16.1527 8.68345C16.1527 8.68345 15.1547 7.22433 13.0081 6.74912C14.8681 6.74281 22.7711 6.75027 22.7711 6.75027Z'
        fill='#E7CE12'
      />
      <path
        d='M6.78096 13.507C5.85084 11.9023 2.02795 5.32373 2.02795 5.32373L6.93069 10.1554C6.93069 10.1554 6.42686 11.1879 6.6179 12.6626L6.78096 13.507Z'
        fill='#BC332C'
      />
      <defs>
        <linearGradient
          id='paint0_linear_250_519'
          x1='11.9391'
          y1='7.69709'
          x2='11.9391'
          y2='16.25'
          gradientUnits='userSpaceOnUse'
        >
          <stop stopColor='#A2C0E6' />
          <stop offset='1' stopColor='#406CB1' />
        </linearGradient>
      </defs>
    </svg>
  );
};

export default Icon;
